// Error logging utility for consistent error handling across pages

/**
 * Log an error with consistent formatting
 * @param {string} component - Component/page name where error occurred
 * @param {string} action - Action being performed when error occurred
 * @param {Error} error - Error object
 * @param {Object} [context] - Additional context data
 */
export const logError = (component, action, error, context = {}) => {
  const errorInfo = {
    timestamp: new Date().toISOString(),
    component,
    action,
    error: {
      message: error.message,
      name: error.name,
      stack: process.env.NODE_ENV === 'development' ? error.stack : undefined
    },
    context: {
      ...context,
      // Include response data if available
      responseData: error.response?.data,
      status: error.response?.status
    }
  };

  // In development, show full error details
  if (process.env.NODE_ENV === 'development') {
    console.error('Error Details:', errorInfo);
  } else {
    // In production, log minimal information
    console.error(`${component} - ${action}: ${error.message}`);
  }

  return errorInfo;
};

/**
 * Format error message for user display
 * @param {Error} error - Error object
 * @param {string} defaultMessage - Default message if error doesn't have one
 * @returns {string} Formatted error message
 */
export const formatErrorMessage = (error, defaultMessage = 'An error occurred') => {
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  return error.message || defaultMessage;
}; 